import {RouterModule} from '@angular/router';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {PushComponent} from "./push/push.component";
import {ChatComponent} from "./chat/chat.component";
import {NotFoundComponent} from "./not-found/not-found.component";

export const routes: any = [
  {path: 'dashboard', component: DashboardComponent, label: 'Dashboard'},
  {path: 'push', component: PushComponent, label: 'Push'},
  {path: 'chat', component: ChatComponent, label: 'Chat'},
  {path: '**', component: NotFoundComponent}
];

export const appRoutingProviders: any[] = [];

export const appRoutes: any = RouterModule.forRoot(routes, { useHash: false });



// WEBPACK FOOTER //
// ./src/app/app.routes.ts